// https://uoften.com/article/185246.html

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import enManual from './enManual.json'

import zh from './zh.json'
import id from './id.json'
import { getQueryString } from '@/utils'
const resources = {
  en: {
    translation: { ...en, ...enManual }
  },
  zh: {
    translation: zh
  },
  id: {
    translation: id
  }
}

// 导出语言枚举
export const langEnum = {
  zh: 'zh',
  en: 'en',
  id: 'id',
  'zh-CN': 'zh',
  'en-US': 'en',
  'id-ID': 'id'
}

const browserLang = navigator.language || navigator.userLanguage
// 多语言
export const lang =
  langEnum[getQueryString('lang')] ||
  langEnum[window.localStorage['lang']] ||
  langEnum[browserLang] ||
  langEnum['zh-CN']

const initLanguage = lang

i18n.use(initReactI18next).init({
  resources,
  lng: initLanguage,
  interpolation: {
    escapeValue: false
  }
})

// 切换语言
export const changeLanguage = lang => {
  let langKey = langEnum[lang] || langEnum['zh']
  i18n.changeLanguage(langKey)
  window.localStorage.setItem('lang', langKey)
}

export default i18n
